// extracted by mini-css-extract-plugin
export var messageSideLeft = "_oz-1";
export var messageSideRight = "_oz-2";
export var subscribeToBackInStockBubbleContainer = "_oz-0";